import theme, { Colors } from '@qnpm/q-theme';
const popupLayerColors = Colors.scenes.popupLayerColors;
const { font, responsive: { scale } } = theme;
class NavBarStyle {
    constructor(isScale) {
        this.getStyle = () => {
            const wrap = {
                flex: 1,
                justifyContent: 'flex-end'
            };
            const mask = {
                backgroundColor: popupLayerColors.maskBackground,
                opacity: 0.5
            };
            const content = {
                backgroundColor: popupLayerColors.contentBackground,
                flexDirection: 'column'
            };
            const absolute = {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
            const header = {
                height: scale(48, this.isScale),
                backgroundColor: '#FFFFFF',
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                position: 'relative'
            };
            const directContent = {
                position: 'absolute',
                left: scale(16, this.isScale),
                top: scale(16, this.isScale),
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            };
            const directText = {
                fontSize: this.fontSize.fontSizeM,
                color: Colors.scenes.baseColor.text1,
                marginLeft: 6
            };
            const headerText = {
                fontSize: this.fontSize.fontSizeL,
                color: popupLayerColors.titleColor,
                lineHeight: scale(48, this.isScale),
                paddingHorizontal: scale(20, this.isScale),
                flex: 1,
                fontWeight: 'bold',
                textAlign: 'center'
            };
            const icon = {
                position: 'absolute',
                right: scale(12, this.isScale),
                top: scale(12, this.isScale)
            };
            const headerContent = {
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            };
            return {
                wrap,
                mask,
                content,
                absolute,
                header,
                headerText,
                icon,
                headerContent,
                directContent,
                directText
            };
        };
        this.isScale = !!isScale;
        this.fontSize = isScale ? font.size.scaled : font.size.unscaled;
    }
}
export default NavBarStyle;
